// libs
import React, { memo, useEffect } from "react";

// global components
import WithStyles from "shared/components/WithStyles";

// components
import Discount from "components/Header/Discount";

// analytics
import DTM from "shared/helpers/DTM";

// styles
import { cssObject } from "./styles";

// defs
export interface IPromotionalBannerStateProps {
    selectedCurrency: string;
    selectedCountry: string;
    currencyDisplayValue: string;
}

export interface IPromotionalBannerDispatchProps {
    openCountryCurrencySettings: VoidFunction;
}

export interface IPromotionalBannerProps
    extends IPromotionalBannerStateProps,
        IPromotionalBannerDispatchProps {}

const PromotionalBanner = ({
    openCountryCurrencySettings,
    selectedCurrency,
    currencyDisplayValue,
    selectedCountry,
}: IPromotionalBannerProps) => {
    useEffect(() => {
        DTM.currency = selectedCurrency;
    }, [selectedCurrency]);

    currencyDisplayValue = currencyDisplayValue !== selectedCurrency ? currencyDisplayValue : "";
    const showDropArrow = currencyDisplayValue || selectedCurrency;
    return (
        <WithStyles cssProps={cssObject}>
            <section className="banner">
                <button className="appliedCurrency" onClick={openCountryCurrencySettings}>
                    {currencyDisplayValue} {selectedCurrency}
                    {showDropArrow && <i className="down" />}
                    {selectedCountry}
                </button>
                <Discount />
            </section>
        </WithStyles>
    );
};

export default memo(PromotionalBanner);
